import { createFileRoute, Link } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { z } from 'zod';
import { rotaDaPlataforma } from '@/features/permissoes/guardas';
import { Personalizacao } from '@/features/personalizacao/componentes/Personalizacao';

const busca = z.object({ nome: z.string().optional().catch(undefined) });

/** Cores do painel de uma academia: só o super-admin personaliza (spec 012, CA-04 a CA-06). */
export const Route = createFileRoute('/_autenticado/plataforma/personalizacao/$id')({
  ...rotaDaPlataforma('Personalização'),
  validateSearch: busca,
  component: Pagina,
});

function Pagina() {
  const { id } = Route.useParams();
  const { nome } = Route.useSearch();
  return (
    <>
      <Link
        to="/plataforma/empresas"
        className="mb-4 inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground"
      >
        <ArrowLeft className="size-4" aria-hidden />
        Academias
      </Link>
      <Personalizacao empresaId={id} nome={nome} />
    </>
  );
}
